import axios from 'axios';
import { constants } from '../../Helpers/constantsFile';

/**
 * What the dashboard asks the server for.
 *
 * Deliberately little: there is no reports endpoint that answers a daily
 * trend, an item mix or a staff split, and the orders list already returns
 * whole orders with the waiter and the customer attached — so the screen asks
 * for orders and works the rest out on the till. That keeps this to two calls
 * for most periods, and three for a manager who also sees cancellations.
 */

const auth = (token) => ({ headers: { Authorization: token } });

/**
 * Orders in a window.
 *
 * Canceled orders never come back from here — the controller filters
 * `orderStatus: { $ne: 'canceled' }` — so anything in this list counts toward
 * revenue without further filtering.
 *
 * A waiter's token is quietly narrowed to their own orders by the same
 * controller, which is one of the reasons this screen is not shown to them.
 */
export async function fetchOrders({ businessId, start, end, token, signal }) {
  const { data } = await axios.get(
    `${constants.baseUrl}/orders/get-business-orders/${businessId}` +
      `?startDate=${start}&endDate=${end}`,
    { ...auth(token), cancelToken: signal }
  );
  return data?.data?.orders || [];
}

/**
 * Cancellations, manager only.
 *
 * A separate call because they live outside the orders list, and filtered on
 * `canceledAt` rather than the order date — the question is "what was voided
 * today", not "what was voided that had been ordered today".
 */
export async function fetchCanceledOrders({ businessId, start, end, token, signal }) {
  const { data } = await axios.get(
    `${constants.baseUrl}/orders/get-canceled-orders/${businessId}` +
      `?startDate=${start}&endDate=${end}`,
    { ...auth(token), cancelToken: signal }
  );
  return data?.data?.orders || [];
}
